import { render, staticRenderFns } from "./LoginV2.vue?vue&type=template&id=7611575a&scoped=true&"
import script from "./LoginV2.vue?vue&type=script&lang=js&"
export * from "./LoginV2.vue?vue&type=script&lang=js&"
import style0 from "./LoginV2.vue?vue&type=style&index=0&id=7611575a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7611575a",
  null
  
)

component.options.__file = "LoginV2.vue"
export default component.exports